<template>

<v-dialog
      v-model="showDialog"
      width="900" scrollable
    >
    <v-card height="600">
        <v-card-title class="text-h5">
          {{$t('wkt.admin.dashboards.select.title')}}
          <v-tabs v-model="tab" align-with-title class="mt-3">
                <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab v-for="cat in categories" :key="cat.id">{{$t(cat.name)}}</v-tab>
                </v-tabs>
        </v-card-title>
        <v-card-text @wheel="onWheel">
                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="cat in categories" :key="cat.id">
                        <v-row style="margin:0px">
                            <v-col cols="6" v-for="item in getCategoryWidgets(cat.id)" :key="item.id">
                                <SelectWidgetCard :widget="item" :currentLicense="currentLicense" v-on:select-widget="(widget) => $emit('select-widget', widget)"/>
                            </v-col>
                            <v-col cols="12" v-if="!getCategoryWidgets(cat.id) || getCategoryWidgets(cat.id).length==0 ">
                                <div class="transparent empty-state center-align">
                                    <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
                                        <div class="text-center">
                                            <i class="large material-icons" style="cursor: pointer;">widgets</i>
                                            <h4>{{$t('wkt.admin.dashboards.select.qb.empty-title')}}</h4>
                                            <p>{{$t('wkt.admin.dashboards.select.qb.empty-subtitle')}}</p>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="$emit('select-widget')">{{$t('wkt.admin.common.dialog-buttons.close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
 

import BaseModule from '../../common/BaseModule.js' 
import SelectWidgetCard from './SelectWidgetCard'

  export default {
    name: 'SelectWidgetDialog',
    mixins: [BaseModule],
    components: {
        SelectWidgetCard
    },
    props: ['showDialog', 'widgets', 'currentLicense' , 'savedQueries'],
    mounted() {  
    },
    methods: {
        onWheel(event) {
            event.stopPropagation()
        },
        getCategoryWidgets(cat) {
            if (!this.widgets) return [];
            if (cat==='qb') {
                return this.savedQueries.map(sq => {
                    let qbw = [];
                    qbw.id = 'QB'+sq.id;
                    qbw.categories = 'qb';
                    qbw.type=100;
                    qbw.license=2;
                    qbw.title=sq.title;
                    qbw.isAllowed=true;
                    qbw.fields = JSON.stringify({
                            addedColumns: sq.addedColumns,
                            addedFilters: sq.addedFilters,
                            rawQuery: "",
                            maxResults: sq.numberRows,
                            entity: sq.entity
                    });
                    return qbw;
                });
            }
            return this.widgets.filter(w=> !w.categories || w.categories.indexOf(cat)>=0);
        }
    },
    data() {
      return {
        tab: null,
        categories: [
            { 'id':'staff',
              'name': 'wkt.admin.dashboards.select.category.staff' },
              { 'id':'check-in',
              'name': 'wkt.admin.dashboards.select.category.check-in' },
              { 'id':'processes',
              'name': 'wkt.admin.dashboards.select.category.processes' },
              { 'id':'qb',
              'name': 'wkt.admin.dashboards.select.category.qb' },
              { 'id':'other',
              'name': 'wkt.admin.dashboards.select.category.other' }]
      }
    }
  }
  </script>
  